<template>
  <md-card v-if="chartData">
    <md-card-content>
      <bar-chart
        :chart-data="chartData"
        :title="$t('assignment_overall.toefl_component_scores')"
        :ticks-config="ticksConfig"
      ></bar-chart>
    </md-card-content>
  </md-card>
</template>
<script>
import BarChart from "@/components/Base/BarChart";
import { service_paths, service_names } from "@/constants/Services";
import { COLOR_BAR_CHART_TOEFL_OVERALL } from "@/helpers/color-chart-config";
import { capitalizeFirstLetter } from "@/helpers/utils";

export default {
  components: { BarChart },
  data() {
    return {
      chartData: null,
      ticksConfig: {
        yAxes: {
          callback: function(value, index, ticks) {
            //convert yaxes to percentage
            return (10 - index) * 10 + "%";
          }
        },
        reverse: true
      }
    };
  },
  methods: {
    getBarchartData(params) {
      this.$axios
        .get(`${service_names.school}/toefl/component-score`, params)
        .then(response => {
          const { label, data } = response.data;
          const dataSets = data?.map(item => {
            return {
              ...item,
              backgroundColor: COLOR_BAR_CHART_TOEFL_OVERALL[item.label]
            };
          });
          this.chartData = {
            labels: label.map(item => capitalizeFirstLetter(item)),
            datasets: dataSets.reverse(),
            percentageData: true
          };
        });
    }
  }
};
</script>
